import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const archivedWorkItemsJwmRoute: InvariantJiraRoute = {
	name: 'classic-business-archived-work-items',
	path: '/jira/core/projects/:projectKey/archived-work-items',
	exact: true,
};
